interface XPProgressBarProps {
  fraction: number;
}

/** Thin animated bar in the header. fraction is clamped to [0, 1]. */
export function XPProgressBar({ fraction }: XPProgressBarProps) {
  const pct = Math.max(0, Math.min(1, fraction)) * 100;
  return (
    <div className="h-1.5 w-full bg-bg-3 rounded-full overflow-hidden">
      <div
        className="h-full rounded-full transition-[width] duration-300 ease-out"
        style={{
          width: `${pct}%`,
          background: "linear-gradient(90deg, var(--color-cyan), var(--color-green))",
        }}
      />
    </div>
  );
}
